import Config from "src/Constants/Config";

const getAssetPath = (resourse: string) => Config.BASE_URL + resourse;

export default getAssetPath;
